export default function FinalCTASection() {
  return (
    <section id="son-cta" className="py-16 md:py-24 bg-primary-500">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 mb-4">
          CiftlikWeb Pro ile işletmenizi tek sistemde toplamaya hazır mısınız?
        </h2>
        <p className="text-primary-100 text-base md:text-lg mb-8 leading-relaxed">
          Paket karmaşası yok. Kurulum, aylık kullanım, domain sahipliği ve DNS yönetimi baştan net; operasyonunuz tek panelden yönetilir.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#demo"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-primary-600 text-sm md:text-base font-semibold rounded-md hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
          >
            Demo ve Kurulum Görüşmesi
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="#kurban-operasyon"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-200 text-background-50 text-sm md:text-base font-semibold rounded-md hover:border-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
          >
            Tek Ürün Modeli
            <i className="ri-price-tag-3-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
